import DynamicBackground from "./subcomponents/DynamicBackground/DynamicBackground";
import FormComponent from "./subcomponents/UserForm";
const Authorization = () => {
  return (
    <DynamicBackground>
      <FormComponent />
    </DynamicBackground>
  );
};

export default Authorization;
